import { render } from "./vresourcesclassifyedit.vue?vue&type=template&id=4d04dcb4&scoped=true"
import script from "./vresourcesclassifyedit.vue?vue&type=script&lang=js"
export * from "./vresourcesclassifyedit.vue?vue&type=script&lang=js"

import "./vresourcesclassifyedit.vue?vue&type=style&index=0&id=4d04dcb4&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d04dcb4"]])

export default __exports__